import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LiveCircuitsDTO } from 'src/app/shared/interfaces/pastell/live-circuit-dto.interface';
import { ExchangeBoxResultDTO, ExchangeConfigurationDTO, ExchangeEmailDTO } from '../interfaces/exchange/exchange-dto.interface';
import { CreateEmailSharedBox, EmailSharedBoxDto } from '../interfaces/exchange/office365-shared-mailbox.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConnectorsService {
  private iContactBaseUrl: string;
  private iCourrierURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iContactBaseUrl = config.apiICourrierBaseUrl;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  // #region Microsoft 365
  public checkExternalIds(listId: string[]): Observable<{ externalIds: string[] }> {
    return this.http.post<{ externalIds: string[] }>(`${this.iContactBaseUrl}/Connecteurs/Office365/CheckExternalIds`, { externalIds: listId });
  }
  public flagExternalIds(listId: string[]): Observable<number> {
    return this.http.post<number>(`${this.iContactBaseUrl}/Connecteurs/Office365/FlagExternalIds`, { externalIds: listId });
  }

  public getEmailSharedBoxes(): Observable<EmailSharedBoxDto[]> {
    return this.http.get<EmailSharedBoxDto[]>(`${this.iContactBaseUrl}/Me/EmailSharedBoxes`);
  }

  public addEmailSharedBox(data: CreateEmailSharedBox): Observable<EmailSharedBoxDto> {
    return this.http.post<EmailSharedBoxDto>(`${this.iContactBaseUrl}/Me/EmailSharedBoxes`, data);
  }

  public deleteEmailSharedBoxes(ids: number[]): Observable<void> {
    return this.http.delete<void>(`${this.iContactBaseUrl}/Me/EmailSharedBoxes`, { params: { ids } });
  }

  //#endregion

  //#region Exchange

  public getBoxIn(autorization: string): Observable<ExchangeBoxResultDTO[]> {
    const headers = new HttpHeaders({
      AuthorizationExchange: autorization,
    });
    return this.http.get<ExchangeBoxResultDTO[]>(`${this.iCourrierURL}/Connecteurs/Exchange/Inbox`, { headers });
  }

  public getBoxOut(autorization: string): Observable<ExchangeBoxResultDTO[]> {
    const headers = new HttpHeaders({
      AuthorizationExchange: autorization,
    });
    return this.http.get<ExchangeBoxResultDTO[]>(`${this.iCourrierURL}/Connecteurs/Exchange/Outbox`, { headers });
  }

  public getExchangesParams(): Observable<ExchangeConfigurationDTO> {
    return this.http.get<ExchangeConfigurationDTO>(`${this.iCourrierURL}/Connecteurs/Exchange/Configuration`);
  }

  public getEmailByIDFromExchange(authorization: string, data: { mailUniqueId: string }): Observable<Blob> {
    const headers = new HttpHeaders({
      AuthorizationExchange: authorization,
      responseType: 'blob',
    });
    return this.http.post<Blob>(`${this.iCourrierURL}/Connecteurs/Exchange/ExportMailEML`, data, {
      headers,
      responseType: 'blob' as 'json',
    });
  }
  public postEmailByIDFromExchange(
    authorization: string,
    data: { mailUniqueId: string; markAsUsed?: boolean },
    encoding: string
  ): Observable<ExchangeEmailDTO> {
    const headers = new HttpHeaders({
      AuthorizationExchange: authorization,
    });
    return this.http.post<ExchangeEmailDTO>(`${this.iCourrierURL}/Connecteurs/Exchange/ExportMail?encoding=${encoding}`, data, {
      headers,
    });
  }

  public deleteMailExchange(autorization: string, data: { mailUniqueId: string }): Observable<void> {
    const options = {
      headers: new HttpHeaders({
        AuthorizationExchange: autorization,
      }),
      body: data,
    };
    return this.http.delete<void>(`${this.iCourrierURL}/Connecteurs/Exchange/DeleteMail`, options);
  }

  public putBoitePartagee(data: { boitesPartagees: string[] }): Observable<void> {
    return this.http.patch<void>(`${this.iCourrierURL}/Connecteurs/Exchange/BoitesPartagees`, data);
  }

  //#endregion

  //#region Pastell
  public getLiveCircuit(): Observable<LiveCircuitsDTO[]> {
    return this.http.get<LiveCircuitsDTO[]>(`${this.iCourrierURL}/Connecteurs/Pastell/LiveCircuits`);
  }
  //#endregion

  public postEncryptExchange(base64LoginPassword: string): Observable<string> {
    return this.http.post<string>(`${this.iCourrierURL}/Global/Encrypt?toCprytString`, { plainText: base64LoginPassword });
  }
}
